<template>
  <div class="paperIndex dataList plr16">
    <div class="ptb16">旧版套餐</div>
    <div class="mains-content">
      <div class="boxs br10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="套餐名称管理" name="first" v-perm="{key:'paperCardInput', value:'paperCardInput:list'}">
            <div class="member-content-box">
              <div class="member-header plr16 mb10">
                <el-select v-model="firstQuery.sourceFrom" class="mr10" @change="onChange">
                  <el-option label="纸质套餐" value="paper"></el-option>
                  <el-option label="电子套餐" value="card430"></el-option>
                </el-select>
                <el-button type="primary" class="small-btn" @click="edits()" v-perm="{key:'paperCardInput', value:'paperCardInput:add'}">新增</el-button>
              </div>
              <div class="plr16">
                <el-table :data="firstList" :max-height="height - 308" header-cell-class-name="table_header_bgcolor">
                  <el-table-column
                    :prop="index"
                    :align="item.align"
                    :label="item.label"
                    :width="item.width"
                    :min-width="item.minWidth"
                    :show-overflow-tooltip="false"
                    v-for="(item,index) in firstConfig"
                    :key="index"
                  >
                    <template slot-scope="scope">
                      <div>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                      <el-link type="primary" @click="edits(scope.row)">编辑</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <paging :totalCount="firstTotal" @doPageQuery="doDataQuery"></paging>
              </div>
            </div>
            <first-edits ref="firstSetForm" @change="firstChange"></first-edits>
          </el-tab-pane>
          <el-tab-pane label="套餐顾客管理" name="second" v-perm="{key:'paperCardInput', value:'paperCardInput:customerList'}">
            <div class="member-content-box plr16">
              <div class="member-header mb10">
                <div class="flex-row">
                  <el-select v-model="query.sourceFrom" class="mr10">
                    <el-option label="纸质套餐" value="paper"></el-option>
                    <el-option label="电子套餐" value="card430"></el-option>
                  </el-select>
                  <el-input
                    placeholder="请输入手机号码/姓名"
                    v-model="query.keyword"
                    clearable
                    maxlength="11"
                    prefix-icon="el-icon-search"
                    class="width160 mr10"
                  ></el-input>
                  <el-button type="primary" @click="rulesMobile">搜索</el-button>
                </div>
                <el-button type="primary" @click="addClick()" v-perm="{key:'paperCardInput', value:'paperCardInput:customerAdd'}">新增</el-button>
              </div>
              <el-table :data="list" :max-height="height - 308" header-cell-class-name="table_header_bgcolor" :summary-method="getSummaries" show-summary>
                <el-table-column
                  :prop="index"
                  :align="item.align"
                  :label="item.label"
                  :width="item.width"
                  :min-width="item.minWidth"
                  :show-overflow-tooltip="false"
                  v-for="(item,index) in columns"
                  :key="index"
                >
                  <template slot-scope="scope">
                    <div>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="addClick(scope.row)">编辑</el-link>
                    <el-link type="primary" class="ml10" @click="detailPage(scope.row)">详情</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
            <edit-set ref="editSetForm" @change="editChange"></edit-set>
            <detail-set ref="detailSetForm"></detail-set>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    
  </div>
    
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import firstConfig from "./config/firstColumns";
import config from "./config/columns";
import editSet from "./edit";
import detailSet from "./detail";
import firstEdits from "./firstEdit.vue";
export default {
  mixins: [minxin],
  data () {
    return {
      activeName: 'first',
      firstList: [],
      firstTotal: 0,
      firstQuery: {
        keyword: "",
        sourceFrom: "paper",
        size: 20,
        start: 1
      },
      firstConfig: firstConfig.columns,
      columns: config.columns,
      list: [],
      url: this.$url.cardOldBook.list,
      query: {
        keyword: "",
        sourceFrom: "paper",
        size: 20,
        start: 1
      },
      totals: {},
      height: this.$store.getters.MainHeight,
    }
  },
  created () {
    this.firstData();
  },
  components: {editSet,detailSet,firstEdits},
  methods: {
    firstData () {
      this.totalCount = 0;
      this.$api.post(this.$url.cardOld.lists, this.firstQuery).then(res => {
        this.firstList = res;
      }).catch(error => {});
      this.$api.post(this.$url.cardOld.counts, this.firstQuery).then(res => {
        this.firstTotal = res;
      }).catch(error => {});
    },
    edits(item) {
      item == undefined
        ? this.$refs["firstSetForm"].$emit("set", null)
        : this.$refs["firstSetForm"].$emit("set", item);
    },
    onChange () {
      this.firstData();
    },
    firstChange (org) {
      if (org) this.firstData();
    },

    handleClick (tab,event) {
      console.log(tab,event)
      if (tab.name == "first") {
        this.firstData();
      } else {
        this.totalCounts();
        this.getTotal();
      }
    },
     getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        sums[0] = "汇总";
        sums[4] = this.totals.originNum;
        sums[5] = this.totals.useNum;
      });
      return sums;
    },
    getTotal () {
      this.$api.post(this.$url.cardOld.cardTotal,this.query).then(res => {
          this.totals = res;
      })
    },
    // cardOld.cardTotal
    back() {
      this.$router.push("/dataList/paperSetMeal");
    },
    addClick(item) {
      item == undefined
        ? this.$refs["editSetForm"].$emit("set", null)
        : this.$refs["editSetForm"].$emit("set", item);
    },
    rulesMobile() {
      this.list = [];
      this.query.start = 1;
      this.totalCounts();
      this.getTotal();
    },
    totalCounts () {
      this.totalCount = 0;
      this.$api.post(this.$url.cardOldBook.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    removeDoQuery() {
      this.query = {
        keyword: "",
        start: 1,
        size: 20
      };
      this.totalCounts();
      this.getTotal();
    },
    editChange(bool) {
      if (bool) {
        this.query = {
          keyword: "",
          start: 1,
          size: 20
        };
        this.totalCounts();
        this.getTotal();
      }
    },
    detailPage(item) {
      this.$refs["detailSetForm"].$emit("set", item);
    }
  }
}
</script>

<style lang="less" scoped>
.paperIndex-box {
    width: 200px;
    margin: 30px auto 0;
    padding: 20px;
    text-align: center;
    background: #fff;
}
.member-header {
  display: flex;
  justify-content: space-between;
}
/deep/ .el-tabs__nav-wrap {
  padding: 10px 10px 0;
}
</style>